module.exports = __webpack_public_path__ + "static/media/140-east-timor.2bb7b98b.svg";